import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    encapsulation: ViewEncapsulation.None
})

export class FooterComponent implements OnInit {
    @Input() showAdminLink: boolean = true;
    currentYear;

    constructor() { }

    ngOnInit(): void {
        this.currentYear = new Date().getFullYear();
    }

    lnkInstagram() {
        window.open("https://www.instagram.com/mega_autoss", '_blank');
    }
}
